import angular from 'angular';

import routing from './signin.routes';
import SigninCtrl from './signin.controller';
import User from '../../models/user';
import lwPageFooter from '../../directives/lw-page-footer';

import HeaderNav from '../../directives/header-nav';
import StatusRow from '../../directives/status-message/status-row';

export default angular.module('app.signin', [User, lwPageFooter, HeaderNav,
    StatusRow
  ])
  .run(['$templateCache', ($templateCache) => {
    $templateCache.put('/signin/signin.fields.html', require(
      './signin.fields.html'));
  }])
  .config(routing)
  .controller('SigninCtrl', SigninCtrl)
  .name;



// WEBPACK FOOTER //
// ./project/pages/signin/index.js